<div class="sidenav-menu">
    <!-- Brand Logo -->
    <a href="javascript:void(0)" class="logo">
        <span class="logo logo-light">
            <span class="logo-lg"><img src="assets/images/logo.svg" alt="Fastglobe logo" /></span>
            <span class="logo-sm"><img src="assets/images/logo-sm.svg" alt="Fastglobe logo" /></span>
        </span>

        <span class="logo logo-dark">
            <span class="logo-lg"><img src="assets/images/logo.svg" alt="Fastglobe logo" /></span>
            <span class="logo-sm"><img src="assets/images/logo-sm.svg" alt="Fastglobe logo" /></span>
        </span>
    </a>

    <!-- Sidebar Hover Menu Toggle Button -->
    <!-- <button class="button-on-hover">
                <i class="ri ri-circle-line align-middle"></i>
            </button> -->

    <!-- Full Sidebar Menu Close Button -->
    <button class="button-close-offcanvas" (click)="closeSidebar()">
        <i class="ri ri-menu-line align-middle"></i>
    </button>

    <div class="scrollbar mt-2" data-simplebar="">
        <div id="user-profile-condensed" class="sidenav-user">
            <div class="dropdown">
                <a class="dropdown-toggle drop-arrow-none link-reset sidenav-user-set-icon" data-bs-toggle="dropdown"
                    data-bs-offset="0,12" href="#!" aria-haspopup="false" aria-expanded="false">
                    <span class="d-flex align-items-center gap-2">
                        <img src="assets/images/users/user-1.jpg" alt="user-image" class="rounded-circle avatar-md" />
                        <span>
                            <span class="sidenav-user-name fw-bold">David Dev</span>
                            <span class="fs-12 fw-semibold" data-lang="user-role">Admin Head</span>
                        </span>
                        <i class="ri ri-arrow-down-s-line align-middle ms-auto"></i>
                    </span>
                </a>

                <div class="dropdown-menu">
                    <!-- Header -->
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow m-0">Welcome back!</h6>
                    </div>

                    <!-- My Profile -->
                    <a href="#!" class="dropdown-item">
                        <i class="ri ri-user-line me-1 fs-lg align-middle"></i>
                        <span class="align-middle">Profile</span>
                    </a>

                    <!-- Settings -->
                    <a href="javascript:void(0);" class="dropdown-item">
                        <i class="ri ri-settings-line me-1 fs-lg align-middle"></i>
                        <span class="align-middle">Account Settings</span>
                    </a>

                    <!-- Lock -->
                    <a href="auth-lock-screen.html" class="dropdown-item">
                        <i class="ri ri-lock-line me-1 fs-lg align-middle"></i>
                        <span class="align-middle">Lock Screen</span>
                    </a>

                    <!-- Logout -->
                    <a href="javascript:void(0);" class="dropdown-item text-danger fw-semibold">
                        <i class="ri ri-logout-box-line me-1 fs-lg align-middle"></i>
                        <span class="align-middle">Log Out</span>
                    </a>
                </div>
            </div>
        </div>

        <!--- Sidenav Menu -->
        <div id="sidenav-menu">
            <ul class="side-nav">

                @for (item of menuItems; track item.label) {

                <!-- Section Title -->
                @if (!item.link && !item.subMenus) {
                <li class="side-nav-item mt-2">{{ item.label }}</li>
                }

                <!-- Menu With Submenu -->
                @else if (item.subMenus) {
                <li class="side-nav-item">
                    <a class="side-nav-link" data-bs-toggle="collapse" [attr.href]="'#submenu-' + item.id"
                        aria-expanded="false">

                        <span class="menu-icon">
                            <i [class]="item.icon"></i>
                        </span>

                        <span class="menu-text">{{ item.label }}</span>

                        <!-- SAME arrow class as static -->
                        <span class="menu-arrow"></span>
                    </a>

                    <!-- SAME collapse structure -->
                    <div class="collapse" [id]="'submenu-' + item.id">

                        <ul class="sub-menu">
                            @for (sub of item.subMenus; track sub.label) {
                            <li class="side-nav-item">
                                <a class="side-nav-link" [routerLink]="sub.link" routerLinkActive="active">
                                    <span class="menu-text">{{ sub.label }}</span>
                                </a>
                            </li>
                            }
                        </ul>
                    </div>
                </li>

                }

                <!-- Normal Menu -->
                @else {
                <li class="side-nav-item">
                    <a class="side-nav-link" [routerLink]="item.link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }">
                        <span class="menu-icon"><i [class]="item.icon"></i></span>
                        <span class="menu-text">{{ item.label }}</span>
                    </a>
                </li>

                }
                }
            </ul>
        </div>

       
    </div>
</div>